import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "preview", "button", "trash", "remove", "placeholder", "fileSize", "buttonLabel", "cropper"];
  static values = {
    image: String,
    fileSize: Number,
  };

  connect() {
    const trashIcon = this.trashTarget;
    this.previewTarget.src = this.imageValue;
    this.hideImagePreview()
    this.handlePreview(this.imageValue)

    if (this.fileSizeValue) this.displayFileSizeFromBytes(this.fileSizeValue);
    const scope = this;

    trashIcon.addEventListener("click", function (e) {
      scope.setRemoveImageInput("true");
      e.preventDefault();
      scope.hideImagePreview();
      scope.clearFileSize();
    });
  }

  hideImagePreview() {
    const useImageAsBackground = document.getElementsByClassName(`${this.inputTarget.id}-image-as-background`)
    this.toggleImageActions(!!this.previewTarget.getAttribute('src'))

    if (this.previewTarget.getAttribute('src')) {
      this.previewTarget.classList.remove('hidden'), this.placeholderTarget.classList.add('hidden');

      if (useImageAsBackground[0] === undefined) return
      for (var i = 0; i !== useImageAsBackground.length; i++) {
        if (useImageAsBackground[i].tagName === 'DIV') {
          useImageAsBackground[i].style.backgroundImage = `url()` 
          continue
        }
        useImageAsBackground[i].classList.remove('hidden')
      }
      return
    }

    this.previewTarget.classList.add('hidden'), this.placeholderTarget.classList.remove('hidden')

    if (useImageAsBackground[0] === undefined) return
    for (var i = 0; i !== useImageAsBackground.length; i++) {
      if (useImageAsBackground[i].tagName === 'DIV') {
        useImageAsBackground[i].style.backgroundImage = `url()`
        continue
      }
      useImageAsBackground[i].classList.add('hidden')
    }
  };

  toggleImageActions(hasImage) {
    if (this.hasButtonLabelTarget) this.buttonLabelTarget.textContent = hasImage ? 'Change' : 'Add';
    if (this.hasCropperTarget) this.cropperTarget.classList.toggle('hidden', !hasImage);
  }

  chooseFile() {
    this.inputTarget.click();
  }

  setRemoveImageInput(value) {
    this.removeTarget.defaultValue = this.removeTarget.value = value;
    this.previewTarget.src = '';
    this.hideImagePreview();
  }

  fileChosen(event) {
    const target = this.previewTarget;
    this.fileToDataUrl(event, (src) => (target.src = src, this.handlePreview(src)));
    this.displayFileSize(event);
  }

  fileToDataUrl(event, callback) {
    if (!event.target.files.length) return;

    let file = event.target.files[0],
      reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = (e) => callback(e.target.result);
  }

  handlePreview(new_src) {
    this.hideImagePreview();

    const useImageAsBackground = document.getElementsByClassName(`${this.inputTarget.id}-image-as-background`)
    if (useImageAsBackground[0] === undefined) return

    for (var i = 0; i !== useImageAsBackground.length; i++) {
      if (useImageAsBackground[i].tagName === 'DIV') return useImageAsBackground[i].style.backgroundImage = `url(${new_src})`
      useImageAsBackground[i].src = new_src
    }
  }

  displayFileSizeFromBytes(bytes) {
    if (!this.hasFileSizeTarget) return;
    const MB = 1024 * 1024;
    const sizeText = bytes >= MB
      ? `${(bytes / MB).toFixed(1)} MB`
      : `${(bytes / 1024).toFixed(1)} KB`;
    this.fileSizeTarget.textContent = sizeText;
    this.fileSizeTarget.classList.remove('hidden');
  }

  displayFileSize(event) {
    if (!this.hasFileSizeTarget) return;
    if (!event.target.files.length) return;
    const file = event.target.files[0];
    this.displayFileSizeFromBytes(file.size);
  }

  clearFileSize() {
    if (!this.hasFileSizeTarget) return;
    this.fileSizeTarget.textContent = '';
    this.fileSizeTarget.classList.add('hidden');
  }
}
